(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-reassurance-delivery]');
    if (!el) return;
    var weekdays = ['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'];
    var months = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
    var d = new Date();
    d.setDate(d.getDate() + 2);
    if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    el.textContent = weekdays[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()];
  })();

  } catch(e) { console.error(e); }
})();
})();
